import { clientApi } from 'api';
import { SearchQuery } from 'dashboard/_redux/actions/users';

const baseUrl = '/dashboard/invoices';

export const getUsersWithInvoices = () => async (searchQuery: SearchQuery<unknown>) => {
  const response = await clientApi.get(baseUrl, { params: searchQuery });

  return response.data;
};

export const getUserInvoices = () => async (userId: string) => {
  const response = await clientApi.get(`${baseUrl}/${userId}`);

  return response.data;
};

export const sendInvoiceByEmail = () => async (invoiceId: string) => {
  const response = await clientApi.post(`${baseUrl}/${invoiceId}/send`);

  return response.data;
};
